import type {SelectOptionItem} from '@logistics-frontend/blocks'

import {i18n} from 'src/shared/config'

export const options: SelectOptionItem[] = [
  {
    value: i18n('profile.form.segment.options.auto_products'),
    label: i18n('profile.form.segment.options.auto_products'),
  },
  {
    value: i18n('profile.form.segment.options.ready_meals_and_cooking'),
    label: i18n('profile.form.segment.options.ready_meals_and_cooking'),
  },
  {
    value: i18n('profile.form.segment.options.children_goods'),
    label: i18n('profile.form.segment.options.children_goods'),
  },
  {
    value: i18n('profile.form.segment.options.documents'),
    label: i18n('profile.form.segment.options.documents'),
  },
  {
    value: i18n('profile.form.segment.options.cosmetics_and_perfumes'),
    label: i18n('profile.form.segment.options.cosmetics_and_perfumes'),
  },
  {
    value: i18n('profile.form.segment.options.furniture'),
    label: i18n('profile.form.segment.options.furniture'),
  },
  {
    value: i18n('profile.form.segment.options.medical_products'),
    label: i18n('profile.form.segment.options.medical_products'),
  },
  {
    value: i18n('profile.form.segment.options.clothing_and_accessories'),
    label: i18n('profile.form.segment.options.clothing_and_accessories'),
  },
  {
    value: i18n('profile.form.segment.options.sporting_products'),
    label: i18n('profile.form.segment.options.sporting_products'),
  },
  {
    value: i18n('profile.form.segment.options.construction_products'),
    label: i18n('profile.form.segment.options.construction_products'),
  },
  {
    value: i18n('profile.form.segment.options.household_goods'),
    label: i18n('profile.form.segment.options.household_goods'),
  },
  {
    value: i18n('profile.form.segment.options.leisure_and_hobby_products'),
    label: i18n('profile.form.segment.options.leisure_and_hobby_products'),
  },
  {
    value: i18n('profile.form.segment.options.pet_supplies'),
    label: i18n('profile.form.segment.options.pet_supplies'),
  },
  {
    value: i18n('profile.form.segment.options.goods_for_holidays'),
    label: i18n('profile.form.segment.options.goods_for_holidays'),
  },
  {
    value: i18n('profile.form.segment.options.everyday_products'),
    label: i18n('profile.form.segment.options.everyday_products'),
  },
  {
    value: i18n('profile.form.segment.options.flowers'),
    label: i18n('profile.form.segment.options.flowers'),
  },
  {
    value: i18n('profile.form.segment.options.electronics_and_household_appliances'),
    label: i18n('profile.form.segment.options.electronics_and_household_appliances'),
  },
  {
    value: i18n('profile.form.segment.options.other'),
    label: i18n('profile.form.segment.options.other'),
  },
]

export const fallbackOption: SelectOptionItem = {
  value: i18n('profile.form.segment.options.other'),
  label: i18n('profile.form.segment.options.other'),
}
